<div class="container-fluid">
  <!-- Tiêu đề Quỹ với biểu tượng -->
  <h3 class="h3 mb-2 text-gray-800"><i class="fas fa-piggy-bank"></i> Quỹ</h3>

  <!-- Mô tả -->
  <p class="lead">Mô-đun Quỹ cho phép bạn quản lý và giám sát các quỹ khác nhau. Bạn có thể thêm, chỉnh sửa và xóa các mục quỹ, theo dõi số tiền quỹ, đặt mức cảnh báo và gán ngân sách.</p>

  <div class="card mb-4">
    <div class="card-body">
      
      <button class="btn btn-outline-primary mb-3" (click)="openAddDialog()">
        
        <span class="icon text-white-50">
          <i class="fas fa-plus"></i>
        </span>
        <span class="text">Thêm Quỹ</span>
      </button>
      <button class="btn btn-outline-info btn-icon-split mb-3" (click)="loadFunds()">
        <span class="icon text-white-50">
          <i class="fas fa-sync-alt"></i>
        </span>
        <span class="text">Làm Mới</span>
      </button>

      <div *ngIf="loadingIndicator; else loaded">
        <div class="d-flex justify-content-center">
          <div class="spinner-border text-primary" role="status">
            <span class="sr-only">Đang tải...</span>
          </div>
        </div>
      </div>

      <ng-template #loaded>
        
        <div>
          <input
            type="text"
            class="form-control"
            placeholder="Tìm kiếm theo tên quỹ..."
            (input)="updateFilter($event)"
          />
        </div>

        <ngx-datatable
          class="bootstrap"
          [rows]="funds"
          [columnMode]="'force'"
          [headerHeight]="50"
          [footerHeight]="50"
          [rowHeight]="'auto'"
          [limit]="10"
          [loadingIndicator]="loadingIndicator"
          [reorderable]="reorderable"
          (select)="onSelect($event)"
          (activate)="onActivate($event)"
        >
        <ngx-datatable-column name="Tên Quỹ" [prop]="'fundName'">
          <ng-template ngx-datatable-cell-template let-row="row">
            <span style="color: red;">{{ row.fundName }}</span>
          </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column name="Mã Quỹ" [prop]="'fundCode'">
          <ng-template ngx-datatable-cell-template let-row="row">
            {{ row.fundCode }}
          </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column name="Số Tiền" [prop]="'amount'">
          <ng-template ngx-datatable-cell-template let-row="row">
            <span style="color: blue;">{{ row.amount }}$</span>
          </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column name="Cảnh Báo ở Phần Trăm" [prop]="'warningAtPercentage'">
          <ng-template ngx-datatable-cell-template let-row="row">
            {{ row.warningAtPercentage }}%
          </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column name="Cảnh Báo ở Số Tiền" [prop]="'warningAtAmount'">
          <ng-template ngx-datatable-cell-template let-row="row">
            {{ row.warningAtAmount }}$
          </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column name="Chủ Sở Hữu" [prop]="'owner'">
          <ng-template ngx-datatable-cell-template let-row="row">
            {{ row.owner }}
          </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column name="Ghi Chú" [prop]="'notes'">
          <ng-template ngx-datatable-cell-template let-row="row">
            {{ row.notes }}
          </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column name="Hành Động">
          <ng-template ngx-datatable-cell-template let-row="row">
            <button class="btn btn-outline-primary btn-sm dropdown-toggle" type="button" id="dropdownMenuButton" data-bs-toggle="dropdown" aria-expanded="false">
              Hành Động
          </button>
          <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton">
            <li>
              <a class="dropdown-item"  (click)="openEditDialog(row)">
                  <i class="fas fa-pencil-alt"></i> Chỉnh Sửa
              </a>
          </li>
          <li>
              <a class="dropdown-item text-danger"  (click)="deleteFund(row.id)">
                  <i class="fas fa-trash-alt"></i> Xóa
              </a>
          </li>
          </ul>
          </ng-template>
        </ngx-datatable-column>
        </ngx-datatable>
      </ng-template>
    </div>
  </div>
</div>
